/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-14 19:13:47
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 15:57:30
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ProductsSelection/ProductSelectionWithHsCode/index.tsx
 */
import React from 'react';
import { RadioGroup, RadioItem } from 'src/components/Antd';
import css from './css.module.less';
import HsCode from './HsCode';
import ProductList from './ProductList';
import Specific from './SpecificProducts';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

export enum Type {
  All = 'All',
  HSCode = 'HsCode',
  Specific = 'Specific',
  Shipping = 'Shipping',
  Order = 'Order',
}

const ProductSelectionWithHsCode = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  // const [hsProducts, setHsProducts] = React.useState([]);
  const { data, onChange, hsCodeError, specificError, disableEdit } =
    props || {};
  const { type, products, hsCodes, dangerousGoodsClasses } = data || {};

  const handleOnTypeChange = (type) => {
    const value = type.target.value;
    if (onChange) {
      if (value === Type.All) {
        onChange({
          products: [],
          hsCodes: [],
          dangerousGoodsClasses: [],
          type: Type.All,
        });
      }
      if (value === Type.HSCode) {
        onChange({
          products: [],
          type: Type.HSCode,
        });
      }
      if (value === Type.Specific) {
        onChange({
          hsCodes: [],
          dangerousGoodsClasses: [],
          type: Type.Specific,
        });
      }
      if (value === Type.Shipping) {
        onChange({
          type: Type.Shipping,
        });
      }
      if (value === Type.Order) {
        onChange({
          type: Type.Order,
        });
      }
    }
  };

  const handleOnHsCodesChange = (codes) => {
    if (onChange)
      onChange({
        hsCodes: codes,
      });
  };

  const handleOnClassesChange = (classes) => {
    if (onChange)
      onChange({
        dangerousGoodsClasses: classes,
      });
  };

  const handleOnProductsChange = (products) => {
    if (onChange)
      onChange({
        products,
      });
  };

  const handleOnSpeProductDelete = (index) => {
    const _products = [...products];
    _products.splice(index, 1);
    handleOnProductsChange(_products);
  };

  return (
    <div className={css.container}>
      <RadioGroup
        value={type}
        onChange={handleOnTypeChange}
        disabled={disableEdit}>
        <div className={css.radioItem}>
          <RadioItem value={Type.All}>
            {getI18n('general.allProducts')}
          </RadioItem>
        </div>
        <div className={`hscodeItem ${css.radioItem}`}>
          <RadioItem value={Type.HSCode}>
            {type == Type.HSCode
              ? getI18n('storeTaxes.taxEditPage.productWithHSCode')
              : getI18n('storeTaxes.taxEditPage.hSCode')}
          </RadioItem>
          {type === Type.HSCode && (
            <Container>
              <HsCode
                onHsCodesChange={handleOnHsCodesChange}
                onClassesChange={handleOnClassesChange}
                hsCodes={hsCodes}
                dangerousGoodsClasses={dangerousGoodsClasses}
                error={hsCodeError}
                //onHsProductChange={setHsProducts}
              />
            </Container>
          )}
        </div>
        <div className={css.radioItem}>
          <RadioItem value={Type.Specific}>
            {getI18n('storeTaxes.taxEditPage.specificProducts')}
          </RadioItem>
          {type === Type.Specific && (
            <Container>
              <Specific
                onProductsChange={handleOnProductsChange}
                products={products}
                error={specificError}
              />
            </Container>
          )}
        </div>
        <div className={css.radioItem}>
          <RadioItem value={Type.Shipping}>
            {getI18n('storeTaxes.taxEditPage.shippingRate')}
          </RadioItem>
        </div>
        <div className={css.radioItem}>
          <RadioItem value={Type.Order}>
            {getI18n('storeTaxes.taxEditPage.order')}
          </RadioItem>
        </div>
      </RadioGroup>
      <Container>
        <ProductList data={data} onDelete={handleOnSpeProductDelete} />
      </Container>

      {/* {type === Type.HSCode && <div>Product List</div>} */}
    </div>
  );
};
export default ProductSelectionWithHsCode;
const Container = (props) => {
  const { children } = props;
  return <div className={css.__wrapper}>{children}</div>;
};
